import {lazy} from './support/lazy';
import {SprintsRepository} from './persistence/sprints_repository';
import {Global} from './models/global';
import {DragContext} from './business/drag_context';
import {SprintApi} from './network/sprint_api';
import {GridLoader} from './business/grid_loader';
import {AvailabilitiesRepository} from './persistence/availabilities_repository';
import {EstimateApi} from './network/estimate_api';
import {SprintSelectionManager} from './business/sprint_selection_manager';
import {EstimatesRepository} from './persistence/estimates_repository';
import {UsersRepository} from './persistence/users_repository';
import {SprintHighlighter} from './business/sprint_highlighter';

export interface Component {
    sprintsRepository: SprintsRepository;
    estimatesRepository: EstimatesRepository;
    availabilitiesRepository: AvailabilitiesRepository;
    usersRepository: UsersRepository;
    sprintApi: SprintApi;
    estimateApi: EstimateApi;
    gridLoader: GridLoader;
    dragContext: DragContext;
    sprintSelectionManager: SprintSelectionManager;
    sprintHighlighter: SprintHighlighter;
}

export class DefaultComponent implements Component {
    constructor(private global: Global) {}

    @lazy()
    public get sprintsRepository(): SprintsRepository {
        return new SprintsRepository(this.global.sprints);
    }

    @lazy()
    public get estimatesRepository(): EstimatesRepository {
        return new EstimatesRepository(this.global.estimates);
    }

    @lazy()
    public get availabilitiesRepository(): AvailabilitiesRepository {
        return new AvailabilitiesRepository(this.global.availabilities);
    }

    @lazy()
    public get usersRepository(): UsersRepository {
        return new UsersRepository(this.global.users);
    }

    @lazy()
    public get gridLoader(): GridLoader {
        return new GridLoader(
            {offset: this.global.offset, numberOfWeeks: 11},
            this.sprintApi,
            this.sprintsRepository,
            this.availabilitiesRepository,
        );
    }

    @lazy()
    public get sprintApi(): SprintApi {
        return new SprintApi();
    }

    @lazy()
    public get estimateApi(): EstimateApi {
        return new EstimateApi();
    }

    @lazy()
    public get dragContext(): DragContext {
        return new DragContext();
    }

    @lazy()
    public get sprintSelectionManager(): SprintSelectionManager {
        return new SprintSelectionManager(this.sprintsRepository);
    }

    @lazy()
    public get sprintHighlighter(): SprintHighlighter {
        return new SprintHighlighter(this.sprintsRepository);
    }
}

declare var GLOBAL: Global;

let instance: Component;

export function component(): Component {
    if (instance === undefined) {
        instance = new DefaultComponent(GLOBAL);
    }

    return instance;
}
